import { render, staticRenderFns } from "./PurchaseFish.vue?vue&type=template&id=01d1b804&scoped=true"
import script from "./PurchaseFish.vue?vue&type=script&setup=true&lang=ts"
export * from "./PurchaseFish.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PurchaseFish.vue?vue&type=style&index=0&id=01d1b804&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d1b804",
  null
  
)

export default component.exports